<header-title [model]="headerTitle"></header-title>

<section class="panel">
    <div class="row mb-3">
        <div class="col col-md-6">
            <button class="btn btn-primary" type="button" [routerLink]="['/audit-template/add']">Add New Audit Template</button>
        </div>
        <div class="col col-md-6">
            <div class="row align-items-center">
                <div class="col col-md-2 text-end">
                    <label class=" control-label">Filter:</label>
                </div>
                <div class="col-md-10">
                    <form [formGroup]="filterForm" *ngIf="filterForm">
                        <input type="text" class="form-control filter-input" formControlName="filterText" placeholder="Start typing to filter list" />
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div class="panel-body">
        <div class="table-responsive">
            <table class="table table-hover mb-none">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Description</th>
                        <th>Category</th>
                        <th>Recurrence (months)</th>
                        <th class="text-center">Active</th>
                        <th class="text-center">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let auditTemplate of auditTemplateList;index as i">
                        <td>{{i+1}}</td>
                        <td>{{auditTemplate.description}}</td>
                        <td>{{auditTemplate.auditCategoryDescription}}</td>
                        <td>{{auditTemplate.recurrence}}</td>
                        <td class="text-center">
                            <span class="fas fa-circle text-primary" data-toggle="tooltip" title="Active" *ngIf="auditTemplate.isActive"></span>
                            <span class="far fa-circle text-primary" data-toggle="tooltip" title="Disabled" *ngIf="!auditTemplate.isActive"></span>
                        </td>
                        <td class="actions text-center">
                            <a [routerLink]="['/audit-template', auditTemplate.id]" class="mb-1 mt-1 me-2 text-primary"><i class="fas fa-edit"></i></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</section>
